import { CheckoutEventTimeout } from '../../models/checkout/checkout-event-timeout.interface';

export const mockCheckoutEventTimeout: CheckoutEventTimeout = {
  transactionId: '123456',
  status: 'timeout',
  eventDescription: 'Checkout timed out',
  ...new CustomEvent('checkout-event-timeout', {
    detail: {
      transactionId: '123456',
      status: 'timeout',
      eventDescription: 'Checkout timed out',
    },
  }),
};
